import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CurrencyService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/currencies`;

  constructor(private http: HttpClient) { }

  getSupported(): Observable<Boo.Objects.Currency[]> {
    return this.http.get<Boo.Objects.Currency[]>(this.baseUrl);
  }
}